import * as actions from './actions';
import {
    GET_TOKENS,
    SET_AGREEMENT_TOKENS,
    SET_TOKENS,
    SET_TOKENS_LOADING_FALSE,
    SET_VAULT_TOKENS,
} from './constants';

import { Token } from '@/shared/api/borrow';

export type TokensState = {
    agreementTokens: Token[];
    vaultTokens: Token[];
    tokens: Token[];
    tokensLoading: boolean;
};

const defaultState: TokensState = {
    agreementTokens: [],
    vaultTokens: [],
    tokens: [],
    tokensLoading: false,
};

type OrderAction = ReturnType<TInferValueTypes<typeof actions>>;

export default function supplies(state = defaultState, action: OrderAction): TokensState {
    switch (action.type) {
        case GET_TOKENS: {
            return {
                ...state,
                tokensLoading: true,
            };
        }
        case SET_AGREEMENT_TOKENS: {
            return {
                ...state,
                agreementTokens: action.payload,
            };
        }
        case SET_VAULT_TOKENS: {
            return {
                ...state,
                vaultTokens: action.payload,
            };
        }
        case SET_TOKENS: {
            return {
                ...state,
                tokens: action.payload,
                tokensLoading: false,
            };
        }
        case SET_TOKENS_LOADING_FALSE: {
            return {
                ...state,
                tokensLoading: false,
            };
        }
        default: {
            return state;
        }
    }
}
